<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Work Shop Name: {{ formData.workShopName || 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Create: {{ formData.createByName || '--' }} at
          {{ formData.createTime || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update: {{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_lable_work_shop_name') || '车间名称'"
            prop="workShopName"
          >
            <el-input
              v-model="formData.workShopName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
              maxlength="36"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row class="mt-2">
      <Process
        ref="process"
        :disabled="disabled"
        :workShopCode="workShopCode"
      />
    </el-row>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import Process from '../process'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { Process },
  mixins: [EditLoading],
  props: {
    workShopCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      formData: { workShopName: '' },
      rules: {
        workShopName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    reload() {
      this.getData()
      this.$refs.process.getData()
    },
    getData() {
      if (!this.workShopCode) return
      this.$api
        .factoryWorkshopDetailApi({
          workShopCode: this.workShopCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      if (!(await validate.formValidate([this.$refs.form]))) return

      const listItem = await this.$refs.process.getTableData()
      if (!listItem || !listItem.length) {
        this.$message.warning(
          this.$l('tips_please_add_factory_workshop_process') ||
            '请添加工厂车间工序'
        )
        return
      }

      this.loadingOpen()
      this.$api
        .factoryWorkshopSaveApi({ ...this.formData, listItem })
        .then(async () => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          if (!this.workShopCode) {
            this.closeCurPage()
          } else {
            this.reload()
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async closeCurPage() {
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
